import { resolveResourcePath } from "./pathContract";

const EXTERNAL_URL_PATTERN =
  /^(?:(?:https?:)?\/\/|[a-z][a-z0-9+.-]*:)/i;

const buildBaseUrl = (currentPath?: string) => {
  if (typeof window !== "undefined" && window.location.href) {
    return window.location.href;
  }

  const normalizedPath = currentPath?.charAt(0) === "/"
    ? currentPath
    : `/${currentPath ?? ""}`;

  return `http://localhost${normalizedPath}`;
};

export const isExternalNavigationTarget = (value?: string | null) =>
  EXTERNAL_URL_PATTERN.test((value ?? "").trim());

export const resolveNavigationTarget = (
  value?: string | null,
  options?: {
    currentPath?: string;
    resourceDefinitionPath?: string | null;
    query?: Record<string, string | null | undefined>;
    /** Transforms internal path for the current surface (e.g. adds siteId prefix in admin). */
    resolvePath?: (path: string) => string;
  }
) => {
  const rawValue = value?.trim();

  if (!rawValue) {
    return null;
  }

  const external = isExternalNavigationTarget(rawValue);
  const resolvedValue = external
    ? rawValue
    : resolveResourcePath(rawValue, options?.resourceDefinitionPath);
  const url = new URL(resolvedValue, buildBaseUrl(options?.currentPath));

  if (!external || /^https?:/i.test(url.protocol)) {
    const query = options?.query ?? {};
    for (const key in query) {
      if (!Object.prototype.hasOwnProperty.call(query, key)) {
        continue;
      }

      const queryValue = query[key];
      if (!queryValue) {
        continue;
      }

      url.searchParams.set(key, queryValue);
    }
  }

  if (external) {
    return { external, href: url.toString() };
  }

  const pathname = options?.resolvePath
    ? options.resolvePath(url.pathname)
    : url.pathname;

  return { external, href: `${pathname}${url.search}${url.hash}` };
};